import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { Api } from 'src/app/providers/app/api.prov';
import { IEnglishStudent } from '../entities/english-student.model';

@Injectable()
export class EnglishStudentProvider {

  constructor(private api: Api) { }

  getAllEnglishStudent() {
    return this.api.get('sg-cle/englishstudent/all')
    .pipe(map(students => students.json()));
}

  getEnglishStudentByStudentId(studentId: string) {
    return this.api.get(`sg-cle/englishstudent/search/student/` + studentId)
      .pipe(map(student => student.json()));
  }

  getEnglishStudentById(id) {
    return this.api.get(`sg-cle/englishstudent/search/` + id)
      .pipe(map(student => student.json()));
  }

  createEnglishStudent(englishStudent: IEnglishStudent) {
    return this.api.post('sg-cle/englishstudent/create', englishStudent)
      .pipe(map(created => created.json()));
  }

  updateEnglishStudent(data, id) {
    return this.api.put('sg-cle/englishstudent/update/' + id, data).pipe(map(res => res.json()));
  }

  updateStatus(id, data) {
    return this.api.put('sg-cle/englishstudent/update/status/' + id, data).pipe(map(res => res.json()));
  }

  getEnglishStudentNoVerified() {
    return this.api.get('sg-cle/englishstudent/students/noverified').pipe(map(student => student.json()));
  }

  deleteEnglishProfile(id){
    return this.api.delete('sg-cle/englishstudent/delete/profile/' + id).pipe(map(res => res.json()));
  }

  getFolderConstancy(){
    return this.api.get('sg-cle/englishstudent/folderid').pipe(map( res=>res.json()));
  }

  getFile(fileId,fileName){
    return this.api.post('drive/get/file',{fileId:fileId,fileName:fileName}).pipe(map( 
        res=>res.json()
    ));
  }

}
